import { createContext } from "react";

export interface InvoicesItemsPageContextType {
  searchQuery: string | undefined; // Debounced search query for API calls
  immediateSearchQuery: string | undefined; // Immediate search query for input field
  setSearchQuery: (query: string | undefined) => void;
  filters: Record<string, string>;
  setFilters: (filters: Record<string, string>) => void;
}

export const InvoicesItemsPageContext =
  createContext<InvoicesItemsPageContextType | null>(null);
